var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boxBtn",
      staticStyle: {
        display: "flex",
        cursor: "pointer",
        "box-shadow": "0px 0px 4px -2px rgba(4, 4, 4, 1)",
        "margin-top": "10px",
        width: "70%",
        height: "50px",
        "flex-direction": "row"
      },
      on: {
        click: function($event) {
          return _vm.eventClick(_vm.link)
        }
      }
    },
    [
      _c("v-img", {
        class: _vm.clase,
        staticStyle: { "margin-left": "0px" },
        attrs: {
          "max-height": "40",
          "max-width": "40",
          width: "40",
          height: "40",
          src: require("../assetsHome/" + _vm.srcs + ".png")
        }
      }),
      _c("div", { staticClass: "txtBtn", staticStyle: { width: "70px" } }, [
        _c(
          "p",
          { staticStyle: { border: "0px" }, attrs: { outline: "", text: "" } },
          [_vm._v(_vm._s(_vm.titulo))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }